import { gql } from '@/__generated__';

export const GATE_MOVEMENT_FRAGMENT = gql(`#graphql
  fragment GateMovementFragment on GateMovement {
    id
    gate {
      id
    }
    operationProgress
    positions
    requestedBy {
      id
      name
    }
    requestedAt
    requestedPosition
    startPosition
    finishPosition
    state
    firmwareMovementId
    direction
    closeCode
    startMissing
    expiresAt
    messages {
      id
      type
      payload
      timestamp
      rawCode
    }
  }
`);
